import { CalcularDeudaTotal, CalculoCuota, verificar_bug } from "../../../functions/FunctionCuota";
import { CreditoDetalles } from "../../../functions/Validaciones/CreditoDetalles";
import { CuotasDetalle } from "../../../functions/Validaciones/CuotasDetalle";
import { tipoConcesion } from "../../shared/Helpers/CalculosConcesiones";
import "../../shared/styles/UnifiedTable.css";

const Tabla_creditos = ({ data, onClick, onChange }) => {
  //Calcular cuotas
  const cuotas = (cuotas) => {
    let result = [];

    cuotas.map((cuota) => {
      let re = CalculoCuota(cuota);
      result.push(re);
    })

    return result;
  }


  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('es-AR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amount);
  };

  const getBadgeClass = (credito) => {
    if (credito.estado === "Pagado") return "unified-badge unified-badge-success";
    if (credito.estado === "Vigente") {
      const vencidas = CuotasDetalle(credito.detalles, credito.concesion).vencidas;
      return vencidas > 0 ? "unified-badge unified-badge-danger" : "unified-badge unified-badge-warning";
    }
    if (credito.estado === "Eliminado") return "unified-badge unified-badge-danger";
    return "unified-badge unified-badge-secondary";
  };

  const getEstadoText = (credito) => {
    if (credito.estado === "Pagado") return "Pagado";
    if (credito.estado === "Vigente") {
      const vencidas = CuotasDetalle(credito.detalles, credito.concesion).vencidas;
      return vencidas > 0 ? "Vencida" : "Vigente";
    }
    if (credito.estado === "Eliminado") return "Eliminado";
    return "";
  };

  return (
    <div className="unified-table-container fade-in">
      <table className="unified-table">
        <thead>
          <tr>
            <th><div>Acciones</div></th>
            <th><div>Cliente</div></th>
            <th><div>Nº Crédito</div></th>
            <th><div>Monto</div></th>
            <th><div>Cuotas</div></th>
            <th><div>Pagas</div></th>
            <th><div>Vencidas</div></th>
            <th><div>Deuda</div></th>
            <th><div>Concesión</div></th>
            <th><div>Estado</div></th>
          </tr>
        </thead>
        <tbody>
          {data.map((credito, index) => (
            <tr key={credito.id} className={verificar_bug(credito.detalles) ? "bg-danger-subtle" : ""}>
              <td>
                <div className="d-flex gap-1">
                  <button
                    className="btn btn-sm btn-danger"
                    title="Eliminar"
                    name="delete_credito"
                    onClick={(event) => onClick(event, credito)}
                    style={{ padding: '6px 10px', borderRadius: '8px' }}
                  >
                    <i className="bi bi-trash"></i>
                  </button>
                  <button
                    className="btn btn-sm btn-success"
                    title="Editar"
                    name="editar_credito"
                    onClick={(event) => onClick(event, credito)}
                    style={{ padding: '6px 10px', borderRadius: '8px' }}
                  >
                    <i className="bi bi-pencil-fill"></i>
                  </button>
                  <button
                    className="btn btn-sm btn-info"
                    title="Ver crédito"
                    name="ver_credito"
                    onClick={(event) => onClick(event, credito)}
                    style={{ padding: '6px 10px', borderRadius: '8px' }}
                  >
                    <i className="bi bi-eye"></i>
                  </button>
                </div>
              </td>
              <td>
                <a
                  href={`/clientes/ver/${credito.persona.id}`}
                  className="unified-table-link"
                >
                  {credito.persona.apellido}, {credito.persona.nombre}
                </a>
              </td>
              <td>
                <span className="fw-semibold">#{credito.id}</span>
              </td>
              <td className="unified-money">
                ${formatCurrency(credito.monto)}
              </td>
              <td>{credito.detalles.length}</td>
              <td>
                <span className="badge bg-success-subtle text-success">
                  {CuotasDetalle(credito.detalles, credito.concesion).pagas}
                </span>
              </td>
              <td>
                <span className="badge bg-danger-subtle text-danger">
                  {CuotasDetalle(credito.detalles, credito.concesion).vencidas}
                </span>
              </td>
              <td className="unified-money">
                ${formatCurrency(CalcularDeudaTotal(0, cuotas(CreditoDetalles(credito).detalles)))}
              </td>
              <td>
                <span className="badge bg-info-subtle text-info">
                  {tipoConcesion(credito.concesion ? credito.concesion.id_tipoconcesion : "") || "-"}
                </span>
              </td>
              <td>
                <span className={getBadgeClass(credito)}>
                  {getEstadoText(credito)}
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Tabla_creditos;
